module.exports = __webpack_public_path__ + "img/rg.0c709515.png";